import React from "react";
import {
  Typography,
  Flex,
  Space,
  Tag,
  Button,
  Input,
  Select,
  Dropdown,
  Menu,
} from "antd";
import { EyeOutlined, MoreOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;

const templates = [
  {
    name: "Lorem ipsum dolor sit amet conse...",
    status: "Active - Pending",
    category: "Marketing",
    language: "English",
    amountSpent: "₹2.35",
    createdAt: "Sep 06, 10:30am",
    locked: true,
  },
  {
    name: "Lorem ipsum dolor sit amet conse...",
    status: "Draft",
    category: "Authentication",
    language: "Hindi",
    amountSpent: "₹2.35",
    createdAt: "Sep 06, 10:30am",
    locked: false,
  },
  // ... More template data here
];

const statusTagColor = (status) => {
  switch (status) {
    case "Active - Pending":
      return "green";
    case "Draft":
      return "default";
    case "In-review":
      return "blue";
    case "Paused":
      return "purple";
    case "Disabled":
      return "red";
    case "Tampered":
      return "orange";
    case "Rejected":
      return "volcano";
    default:
      return "default";
  }
};

const TemplateList = () => {
  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <Flex justify="space-between" className="mb-4 flex-wrap gap-2">
        <Input.Search placeholder="Search..." style={{ maxWidth: 300 }} />
        <Space>
          <Select defaultValue="Status" style={{ width: 120 }}>
            <Option value="Status">Status</Option>
          </Select>
          <Select defaultValue="Category" style={{ width: 120 }}>
            <Option value="Category">Category</Option>
          </Select>
          <Select defaultValue="Language" style={{ width: 120 }}>
            <Option value="Language">Language</Option>
          </Select>
          <Button type="primary">Sync</Button>
        </Space>
      </Flex>

      <div>
        {templates.map((template, index) => (
          <Flex
            key={index}
            align="center"
            justify="space-between"
            className="border-b py-3"
          >
            <Flex align="center" gap="middle">
              <Text strong>{template.name}</Text>
              {template.locked && <span className="text-lg">🔒</span>}
              <Text type="secondary" className="text-xs">
                Created @ {template.createdAt}
              </Text>
            </Flex>

            <Flex align="center" gap="middle">
              <Tag color={statusTagColor(template.status)}>
                {template.status}
              </Tag>
              <Text>{template.category}</Text>
              <Text>{template.language}</Text>
              <Text>{template.amountSpent}</Text>
              <Button icon={<EyeOutlined />} />
              <Button icon={<MoreOutlined />} />
            </Flex>
          </Flex>
        ))}
      </div>
    </div>
  );
};

export default TemplateList;
